export function initOembedContainers() {
   onDomReady(function() {
      // Initialize all oembeds
      $$('.oembedContainer').each(function(oembed) {
         var iframe = oembed.getChildren('iframe');
         if (iframe.length > 0) {
            iframe.set('width', oembed.getStyle('width'));
            iframe.set('height', oembed.getStyle('height'));
         } else {
            return;
         }
      });
   });
}
